import { useState } from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";
import { Linkedin, Download, Mail, Send } from "lucide-react";
import { toast } from "sonner";

export function Contact() {
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    const form = e.target as HTMLFormElement;
    const name = (form.elements.namedItem("name") as HTMLInputElement)?.value;
    const email = (form.elements.namedItem("email") as HTMLInputElement)?.value;
    const contact = (form.elements.namedItem("contact") as HTMLInputElement)?.value;
    const message = (form.elements.namedItem("message") as HTMLTextAreaElement)?.value;

    // WhatsApp message formatting
    const waMessage =
      `Contact From Website:\n ${name}\nEmail: ${email}\nContact: ${contact}\nMessage: ${message}`;
    const waUrl = `https://wa.me/919429431562?text=${encodeURIComponent(waMessage)}`;

    window.open(waUrl, "_blank");
    setTimeout(() => {
      setSubmitting(false);
      toast.success("WhatsApp opened — send your message!");
      form.reset();
    }, 700);
  };

  return (
    <section id="contact" className="py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-14 max-w-2xl">
          <p className="font-mono text-sm text-primary">// Contact</p>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            Let&apos;s build something great.
          </h2>
          <p className="mt-4 text-muted-foreground">
            Whether you need a technical co-pilot or a fresh architectural perspective — I&apos;m
            open to it.
          </p>
        </div>

        <div className="grid gap-10 md:grid-cols-5">
          <form
            onSubmit={onSubmit}
            className="rounded-2xl border border-border bg-surface p-6 shadow-card md:col-span-3 md:p-8"
          >
            
            <div className="mt-5 flex flex-col gap-5">
              <div className="flex flex-col gap-2">
                <Label htmlFor="name">Name</Label>
                <Input id="name" name="name" required placeholder="Your name" />
              </div>
            </div>
            <div className="mt-5 grid gap-5 sm:grid-cols-2">
              <div className="flex flex-col gap-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  required
                  placeholder="you@company.com"
                />
              </div>
              <div className="flex flex-col gap-2">
                <Label htmlFor="contact">Contact Number</Label>
                <Input
                  id="contact"
                  name="contact"
                  type="tel"
                  required
                  placeholder="Your contact number"
                  pattern="[0-9]{10,15}"
                />
              </div>
            </div>
            <div className="mt-5 flex flex-col gap-2">
              <Label htmlFor="message">Message</Label>
              <Textarea
                id="message"
                name="message"
                required
                rows={5}
                placeholder="Tell me about your project…"
              />
            </div>
            <Button
              type="submit"
              variant="hero"
              size="lg"
              className="mt-6 w-full sm:w-auto"
              disabled={submitting}
            >
              {submitting ? "Sending…" : "Send Message"} <Send className="ml-1 h-4 w-4" />
            </Button>
          </form>

          <aside className="flex flex-col gap-4 md:col-span-2">
            <a
              href="https://www.linkedin.com/in/udaymanvar/"
              target="_blank"
              rel="noreferrer"
              className="group flex items-center gap-4 rounded-xl border border-border bg-surface p-5 transition-smooth hover:-translate-y-1 hover:border-primary/50 hover:shadow-elevated"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary/10 text-primary transition-smooth group-hover:bg-primary/20">
                <Linkedin className="h-5 w-5" />
              </div>
              <div>
                <div className="font-semibold text-foreground">LinkedIn</div>
                <div className="text-sm text-muted-foreground">Connect & message me</div>
              </div>
            </a>

            <a
              href="mailto:me@udaymanvar.com"
              className="group flex items-center gap-4 rounded-xl border border-border bg-surface p-5 transition-smooth hover:-translate-y-1 hover:border-primary/50 hover:shadow-elevated"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary/10 text-primary transition-smooth group-hover:bg-primary/20">
                <Mail className="h-5 w-5" />
              </div>
              <div>
                <div className="font-semibold text-foreground">Email</div>
                <div className="text-sm text-muted-foreground">me@udaymanvar.com</div>
              </div>
            </a>
          </aside>
        </div>
      </div>
    </section>
  );
}
